import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../styles/pages.css'; 
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UtilsLocalizedExcelString from '../services/utilsLocalizedExcelString.jsx';

function ResourcesPage(props) {
 const { t } = useTranslation();
  const [excelLoadedSheet, setExcelLoadedSheet] = useState(false);
      const [excelDataSheet, setExcelDataSheet]= useState("");


        useEffect(() => {
 const handleFetchFromUrl = async () => {
    console.log("is this function called");
    if(!excelLoadedSheet) {
    try {
      const url = "https://storage.googleapis.com/fgr-data-visualisation-assets/fgr_silvagris_assets.xlsx";
      const response = await axios.get(url, { responseType: 'arraybuffer' });

      const data = new Uint8Array(response.data);
      const workbook = XLSX.read(data, { type: 'array' });
      console.log(workbook);
      console.log("there are sheetnames?");
      console.log(workbook.SheetNames);
      const sheetName = workbook.SheetNames[5];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setExcelDataSheet(jsonData);
      setExcelLoadedSheet(true);
      console.log(jsonData);
      console.log( excelDataSheet);
    } catch (error) {
    
      console.error('Error fetching or parsing Excel file:', error);
    }
  }
  };
  
  
    handleFetchFromUrl();

  }, [props.lang, excelLoadedSheet]);
  console.log(excelDataSheet !== "" && excelDataSheet[1] !== undefined);
    return (
      <React.Fragment>
         <div className="App">
     {props.argument === "publications" ?
         <div style={{marginTop: "2rem"}}>
           <h5 className="title-body">{t('menu_item_publications')}</h5>
    <br/>
    <hr style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
    }}></hr>
    {excelDataSheet !== "" && 
        <> {(() => {
        let rows = [];
        let arrayPub = excelDataSheet.filter((elem) => elem[0].includes("publication"));
          console.log(arrayPub);
        for (let i = 0; i < arrayPub.length; i+=3) {
          rows.push(<Row key={"publication" + i} className="homepage-row" style={{border: "none", 
          borderRadius: "0px!important", padding:"2rem"}}>
        <a style={{textDecoration : "none"}} href={UtilsLocalizedExcelString(props.lang, arrayPub[i+2])} target='_blank' rel="noreferrer">
        <Col sm={3}>

        <img style={{width: "150px"}} 
       src={"https://storage.googleapis.com/fgr-data-visualisation-assets/publications_images/" + arrayPub[i+1][7]+ "." +  arrayPub[i+1][8]} 
        alt="book SilvaGris related publications" />
          </Col>
        <Col sm={8}>
          <h6 className="title-pub">{UtilsLocalizedExcelString(props.lang, arrayPub[i])}</h6>
          <h3 className="title-year-body">{arrayPub[i][8]}</h3>
          <p className="paragraph-body">{UtilsLocalizedExcelString(props.lang, arrayPub[i+1])}</p>
        </Col></a></Row>);
          rows.push(<br key={"Publication_space" + i}></br>);
        }
        return rows;
      })()} </>}
         </div> : 
         
         
         
         props.argument === "learning" ?
         <div style={{marginTop: "2rem"}}>
           <h5 className="title-body">{t('menu_item_learning')}</h5>
<br/>
<hr style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
}}></hr>
{excelDataSheet !== "" && Array.isArray(excelDataSheet) &&
        <> {(() => {
        let rows = [];
        let arrayLearning = excelDataSheet.filter((elem) => elem[0].includes("learning"));

        for (let i = 0; i < arrayLearning.length; i+=2) {
          rows.push(<div key={arrayLearning[i] + "learning"}><h5 className="title-body">{UtilsLocalizedExcelString(props.lang, arrayLearning[i])}</h5>
            <p  key={arrayLearning[i] + "learningPara"}className="paragraph-body">{UtilsLocalizedExcelString(props.lang, arrayLearning[i+1])}</p>
            <span key={arrayLearning[i] + "learningSpan"}><a style={{ color:"#116AAB", fontSize:"14px" , 
            textDecoration: "none"}} 
            href={arrayLearning[i][7]} 
              target="_blank ">{t('learn_more')} <img  
              src={ props.lang === "ar" ? 
                process.env.PUBLIC_URL + `/img/chevron-left.svg` : 
                process.env.PUBLIC_URL +  `/img/chevron-right.svg`} alt="arrow icon"  /></a></span>

            <hr key={arrayLearning[i] + "learningDivider"} style={{maxWidth: "50px" , border:"0",height:"2px",
            background:"#116bac", opacity: "1",
            }}></hr>
              </div>) ;
        }
        return rows;
      })()} </>}
         </div>  : 
         
         
         
         props.argument === "external-resources" ? 
         <div style={{marginTop: "2rem"}}>
            <h5 className="title-body">{t('external_resources')}</h5>
          <br/>
          <hr style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
            }}></hr>
        {excelDataSheet !== "" && Array.isArray(excelDataSheet) &&
        <> {(() => {
        let rows = [];
        let arrayExternalResources = excelDataSheet.filter((elem) => elem[0].includes("external_resources"));

        for (let i = 0; i < arrayExternalResources.length; i+=2) {
          rows.push(<div key={arrayExternalResources[i] + "externalResources"} ><h5  
          className="title-body">{UtilsLocalizedExcelString(props.lang, arrayExternalResources[i])}</h5>
          <p key={arrayExternalResources[i] + "ExternalResPara"} className="paragraph-body">{UtilsLocalizedExcelString(props.lang, arrayExternalResources[i+1])}</p>
          <span key={arrayExternalResources[i] + "ExternalResSpan"}><a style={{ color:"#116AAB", fontSize:"14px" , textDecoration: "none"}} 
            href={arrayExternalResources[i][7]} target="_blank" rel="noreferrer">{arrayExternalResources[i][7]}</a></span>
              <hr key={arrayExternalResources[i] + "ExternalResSpace"} style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
                  }}></hr>
              </div>) ;
        }
        return rows;
      })()} </>}
         </div> : 
         
         
         
         
         <div style={{marginTop: "2rem"}}>
     <h5 className="title-body">{t('menu_item_networks')}</h5>
<br/>
<hr style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
}}></hr>
 {excelDataSheet !== "" && Array.isArray(excelDataSheet) &&
        <> {(() => {
        let rows = [];
        let arrayNetworks = excelDataSheet.filter((elem) => elem[0].includes("networks"));

        for (let i = 0; i < arrayNetworks.length; i++) {
          rows.push(<div key={arrayNetworks[i] + "networks"}><h5  className="title-body">{UtilsLocalizedExcelString(props.lang, arrayNetworks[i])}</h5>
                <span key={arrayNetworks[i] + "networksSpan"}><a key={arrayNetworks[i] + "link"} style={{ color:"#116AAB", fontSize:"14px" , textDecoration: "none"}} 
            href={arrayNetworks[i][7]}
            target="_blank ">{arrayNetworks[i][7]}</a></span>
            <hr key={arrayNetworks[i] + "networksDivider"} style={{maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
            }}></hr>
              </div>) ;
        }
        return rows;
      })()} </>}
         </div>
        }
        </div>
      </React.Fragment>
    );
  }

  export default ResourcesPage;